import { makeActionCreator } from '../../config/store/utils'
import { getAllProvidersFramework } from '../../services/search'
import { getFrameworks } from '../../services/config'

export const GET_PROVIDERS_BY_FRAMEWORK = 'GET_PROVIDERS_BY_FRAMEWORK'
export const GET_PROVIDERS_BY_FRAMEWORK_ERROR = 'GET_PROVIDERS_BY_FRAMEWORK_ERROR'
export const GET_PROVIDERS_BY_FRAMEWORK_SUCCESS = 'GET_PROVIDERS_BY_FRAMEWORK_SUCCESS'
export const onGetProvidersByFramework = makeActionCreator(GET_PROVIDERS_BY_FRAMEWORK)
export const onGetProvidersByFrameworkError = makeActionCreator(GET_PROVIDERS_BY_FRAMEWORK_ERROR, 'payload')
export const onGetProvidersByFrameworkSuccess = makeActionCreator(GET_PROVIDERS_BY_FRAMEWORK_SUCCESS, 'payload')
export const onGetProvidersByFrameworkThunk = payload => async dispatch => {
  dispatch(onGetProvidersByFramework())
  try {
    const { data = [] } = await getAllProvidersFramework({
      idFrameworkAgreement: payload.frameworkId,
      year: payload.year
    })
    const enhancedData = data?.payload?.map(item => ({
      amountCLP: item?.amountCLP,
      amountUSD: item?.amountUSD,
      dni: item?.rutSupplier,
      name: item?.supplier,
      quantityOC: item?.quantityOC,
      ranking: item?.ranking
    }))
    const csv = [
      ['Nombre proveedor', 'RUT proveedor', 'N° de órdenes de compra', 'Monto transado', 'Monto transado (USD)'],
      ...enhancedData.map(item => [item?.name, item?.dni, item?.quantityOC, item?.amountCLP, item?.amountUSD])
    ]

    return dispatch(onGetProvidersByFrameworkSuccess({ csv, data: enhancedData }))
  } catch (error) {
    return dispatch(onGetProvidersByFrameworkError({ error, csv: [], data: [] }))
  }
}
export const GET_FRAMEWORK = 'GET_FRAMEWORK'
export const GET_FRAMEWORK_ERROR = 'GET_FRAMEWORK_ERROR'
export const GET_FRAMEWORK_SUCCESS = 'GET_FRAMEWORK_SUCCESS'
export const onGetFramework = makeActionCreator(GET_FRAMEWORK)
export const onGetFrameworkError = makeActionCreator(GET_FRAMEWORK_ERROR, 'payload')
export const onGetFrameworkSuccess = makeActionCreator(GET_FRAMEWORK_SUCCESS, 'payload')
export const onGetFrameworkThunk = payload => async dispatch => {
  dispatch(onGetFramework())
  try {
    const frameworksData = await getFrameworks({ year: payload.year })
    const frameworksPayload = frameworksData.data.payload
    const frameworks = frameworksPayload.map(item => ({ id: item.id, name: item.frameworkAgreement, value: item.id }))

    return dispatch(onGetFrameworkSuccess({ frameworks }))
  } catch (error) {
    return dispatch(onGetFrameworkError({ error }))
  }
}
